(() => {
class KuzuTraceabilityLookup {
  constructor(root) {
    this.root = root;
    this.form = root.querySelector('[data-traceability-form]');
    this.input = root.querySelector('[data-traceability-input]');
    this.button = root.querySelector('[data-traceability-submit]');
    this.message = root.querySelector('[data-traceability-message]');
    this.index = this.readIndex();

    if (!this.form || !this.input) return;

    this.form.addEventListener('submit', (event) => this.onSubmit(event));
    this.input.addEventListener('input', () => this.clearMessage());
    this.openBatchFromQuery();
  }

  readIndex() {
    const data = this.root.querySelector('[data-traceability-index]');

    try {
      return JSON.parse(data?.textContent || '{}');
    } catch (_error) {
      return {};
    }
  }

  normalize(value) {
    return value.trim().toUpperCase().replace(/\s+/g, '');
  }

  setMessage(text, state = 'error') {
    if (!this.message) return;

    this.message.textContent = text;
    this.message.dataset.state = state;
  }

  clearMessage() {
    if (!this.message) return;

    this.message.textContent = '';
    delete this.message.dataset.state;
  }

  onSubmit(event) {
    event.preventDefault();

    const code = this.normalize(this.input.value);

    if (!code) {
      this.setMessage('Enter the four-character batch code printed on your KUZŪ product.');
      this.input.focus();
      return;
    }

    if (!/^[A-Z][0-9]{3}$/.test(code)) {
      this.setMessage('Use one letter followed by three numbers, for example A001.');
      this.input.focus();
      return;
    }

    const destination = Object.hasOwn(this.index, code) ? this.index[code] : null;

    if (!destination) {
      this.setMessage('We could not find a published record for that code. Check each letter and number, or contact KUZŪ for help.');
      this.input.focus();
      return;
    }

    let target;
    try {
      target = new URL(destination, window.location.origin);
      if (target.origin !== window.location.origin || !/^https?:$/.test(target.protocol)) throw new Error('Invalid batch URL');
    } catch (_error) {
      this.setMessage('This record is not available at a valid storefront address. Please contact KUZŪ.');
      return;
    }
    this.setMessage('Published record found. Opening its provenance page…', 'success');
    window.location.assign(target.href);
  }

  openBatchFromQuery() {
    const code = new URLSearchParams(window.location.search).get('batch');

    if (!code) return;

    this.input.value = code;
    this.form.requestSubmit();
  }
}

const init = (scope = document) => scope.querySelectorAll('[data-traceability-lookup]').forEach((root) => {
  if (root.dataset.lookupReady) return;
  root.dataset.lookupReady = 'true';
  new KuzuTraceabilityLookup(root);
});
init();
document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
